import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }

  label {
    font-family: "Barlow", sans-serif;
    font-size: 16px;
    color: #fff;
    margin-bottom: 16px;
  }

  input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    border: 1px #4444 solid;
    padding: 16px;
    font-size: 14px;
    color: #fff;
    background-color: #141515;
  }

  span {
    font-size: 14px;
    font-weight: bold;
    color: #f85656;
    margin: 4px 0;
  }
`;
